import React from "react";
import { Box, Typography } from "@mui/material";
import { safeJSONParse } from "../../../utils/helper";
import MarkdownRenderer from "../../MarkdownRenderer";

type TemplateDocumentSelectorAgentProps = {
  parsedContent: any;
};

export default function TemplateDocumentSelectorAgent({
  parsedContent,
}: TemplateDocumentSelectorAgentProps): JSX.Element {
  // Parse the backend response
  const finalAnswer = safeJSONParse(parsedContent?.finalAnswer);

  // Extract question from nested structure
  let question = "";

  if (finalAnswer?.payload?.result?.data?.question) {
    question = finalAnswer.payload.result.data.question;
  } else if (finalAnswer?.result?.data?.question) {
    question = finalAnswer.result.data.question;
  } else if (finalAnswer?.question) {
    question = finalAnswer.question;
  } else if (parsedContent?.question) {
    question = parsedContent.question;
  }

  if (!question) {
    return <Typography>No data available</Typography>;
  }

  return (
    <Box>
      <MarkdownRenderer content={question} />
    </Box>
  );
}
